import objectPath from 'object-path'
import { getWidgetDesign } from './Design'
import { createWidgetOptions } from './Option'

export const createWidgetDesign = async (designContext) => {
  let { widgetDesign, setWidgetDesign, setIsUiChanged, isUiChanged } =
    designContext
  let widgetList = createWidgetOptions(designContext)
  if (widgetList) {
    let filterWidgetList = []
    widgetList.forEach(({ path }) => {
      if (filterWidgetList.includes(path)) return
      filterWidgetList.push(path)
    })
    let promiseAll = filterWidgetList.map(async (widgetCode) => {
      let design = await getWidgetDesign({
        widgetCode: widgetCode,
      })
      return { widgetCode, design }
    })
    await Promise.all(promiseAll).then((resolveData) => {
      resolveData.forEach(({ widgetCode, design }) => {
        objectPath.set(widgetDesign, widgetCode, design)
        objectPath.set(isUiChanged, ['isLoadWidgetDone', widgetCode], true)
      })
      setIsUiChanged(isUiChanged)
      setWidgetDesign(widgetDesign)
    })
  }
}
